import { GET_LIST, CREATE } from 'react-admin';
export const FORM_DATA = 'FORM_DATA';

import * as constants from '../../constants/index';
import {
    CITIES_INFO,
    CREATE_FLIGHT_REQUEST,
    REVIEW_FLIGHT_REQUEST,
    REVIEW_FLIGHT_REQUEST_CLEAR,
    FLIGHT_TYPES_INFO,
    EMPTY_FIELDS,
    CONFIRM_MONITORING_NUMBER,
    FIRST_CONFIRM_MONITORING,
    CONFIRMED_MONITORING,
    FLIGHT_REQUEST_CREATED,
    CREATE_FLIGHT_REQUEST_CLEAR,
    CONFIRM_MONITORING_NUMBER_CLEAR,
    GET_FLIGHT_INFO,
    GET_FLIGHT_INFO_TEST,
    GET_FLIGHT_INFO_SUCCESS,
    GET_FLIGHT_INFO_CLEAR,
    UPDATE_MONITORING_FILE,
    SET_ACCORDION
} from './types';

export const getFlightInfo = (referenceCode: any, flightInfoNumber: any) => ({
    type: GET_FLIGHT_INFO,
    payload: { data: { referenceCode, number: flightInfoNumber } },
    meta: { fetch: CREATE, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FIDS.GET_FLIGHT_INFO}` },
})

export const getFlightInfoTest = (referenceCode: any) => ({
    type: GET_FLIGHT_INFO_TEST,
    payload: { referenceCode },
})

export const setFlightInfo = (data: any) => ({
    type: GET_FLIGHT_INFO_SUCCESS,
    payload: data,
})

export const getCityList = () => ({
    type: CITIES_INFO,
    meta: { fetch: GET_LIST, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.CITY.GET_CITY_LIST}` },
});

export const getFlightTypesList = () => ({
    type: FLIGHT_TYPES_INFO,
    meta: {
        fetch: GET_LIST,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_TYPES.GET_FLIGHT_TYPES}`,
    },
});

export const confirmMonitoringNumber = (data: any) => ({
    type: CONFIRM_MONITORING_NUMBER,
    payload: { data: data },
    meta: {
        fetch: FORM_DATA,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FIDS.CONFIRM_MONITORING_NUMBER}`
    },
});

export const createFlightRequest = (flightRequest: any) => ({
    type: CREATE_FLIGHT_REQUEST,
    payload: { data: flightRequest },
    meta: { fetch: CREATE, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.SUBMIT}` },
});

export const reviewFlightRequest = (flightRequest: any) => ({
    type: REVIEW_FLIGHT_REQUEST,
    payload: { data: flightRequest },
    meta: { fetch: CREATE, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.REVIEW}` },
});

export const emptyFields = (errorMessage: any) => ({
    type: EMPTY_FIELDS,
    errorMessage,
});

export const showErrorNotification = (errorMessage: any) => ({
    type: FIRST_CONFIRM_MONITORING,
    errorMessage,
});

export const confirmedMonitoring = (successMessage: any) => ({
    type: CONFIRMED_MONITORING,
    successMessage,
});

export const flightRequestCreated = (successMessage: any) => ({
    type: FLIGHT_REQUEST_CREATED,
    successMessage,
});

export const updateMonitoringFile = (data: any) => ({
    type: UPDATE_MONITORING_FILE,
    payload: { data: data },
    meta: {
        fetch: FORM_DATA,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FIDS.UPDATE_MONITORING_FILE}`,
    },
});

export const clearFlightRequest = () => ({
    type: CREATE_FLIGHT_REQUEST_CLEAR,
    payload: [],
});

export const clearReviewFlightRequest = () => ({
    type: REVIEW_FLIGHT_REQUEST_CLEAR,
    payload: [],
});

export const clearMonitoringNumber = () => ({
    type: CONFIRM_MONITORING_NUMBER_CLEAR,
    payload: [],
});

export const clearFlightInfo = () => ({
    type: GET_FLIGHT_INFO_CLEAR,
    payload: { data: { flightInfo: [] } },
});

export const setExpandedAccordion = (number: number) => ({
    type: SET_ACCORDION,
    payload: { data: number }
});